module.exports = __webpack_public_path__ + "img/icon-about-1.e696a7f2.png";